import * as z from "zod";

export const uploadUrlResponseSchema = z.object({
  url: z.string(),
});

export type UploadUrlResponse = z.infer<typeof uploadUrlResponseSchema>;
